import ActionPromptApp from './action-prompt';

export default ActionPromptApp;
